import React from "react";
import "./footer.scss";
import logo from "../../media/logo_hiera.png";
import logosinarmas from "../../media/800px-Sinar_Mas_Land_Logo.png";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="logosinarmas" src={logosinarmas} alt="logosinarmas" />
          <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Hiera BSD City</h2>
            <h3>
              Jl. Raya Kadusirung, Kadu Sirung, Kec. Pagedangan, Kabupaten
              Tangerang, Banten 15336
            </h3>
            <h4>Contact us : +6281297520392 (Jason) </h4>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">© Hiera BSD City</div>
    </div>
  );
};

export default footer;
